import React from 'react';

import Grid from '@mui/material/Grid';
import { LinearProgress } from '@mui/material';

const CustomLinearProgress = () => {
  return (
    <Grid className='custom-linear-progress-container'>
      <LinearProgress color='secondary' />
    </Grid>
  );
};

export default CustomLinearProgress;
